( function( $, document ) {
    'use strict';

    $( document ).ready( function() {
        // var swiper = new Swiper('.js-testimonial-carousel .swiper', {
        //     effect: 'fade',
        //     fadeEffect: {
        //         crossFade: true
        //     },
        // });
    } );

} )( jQuery, document );
